        (function () {
        let teardown = null;

        function initCompleteTheLook() {
            const ctlSection = document.querySelector('section.complete-the-look');
            if (!ctlSection) return;
            const content = ctlSection.querySelector('.complete-the-look__content');
            if (!content) return;

            const MAX_RETRIES = 3;
            const RETRY_DELAY = 300;
            const SYNC_DEBOUNCE = 200;

            const sectionId = ctlSection.dataset.sectionId;
            const productUrl = ctlSection.dataset.productUrl;
            const htmlByColor = {};

            let renderedColor = normalizeColor(ctlSection.dataset.selectedColor);
            let pendingColor = null;
            let requestToken = 0;
            let debounceTimer = null;
            let retryTimer = null;
            let retryCount = 0;
            let lastRequestedColor = null;

            if (renderedColor) {
                htmlByColor[renderedColor] = content.innerHTML;
            }

            function normalizeColor(value) {
                return (value || '').trim().toLowerCase();
            }

            function getActiveColor() {
                const scope = document.getElementById('ProductDetails');
                const swatch = scope && scope.querySelector('#color-picker .option-color.active[data-val]');
                if (!swatch) return null;
                return normalizeColor(swatch.getAttribute('data-val')) || null;
            }

            function variantIdForColor(color) {
                const scope = document.getElementById('ProductDetails') || document;
                const sources = [
                    {
                        nodes: scope.querySelectorAll('.variant[data-variant-color][data-variant-id]'),
                        color: (node) => node.getAttribute('data-variant-color'),
                        id: (node) => node.getAttribute('data-variant-id'),
                        available: (node) => node.getAttribute('data-variant-available') === 'true'
                    },
                    {
                        nodes: scope.querySelectorAll('#productSelect option[data-color]'),
                        color: (node) => node.getAttribute('data-color'),
                        id: (node) => (node.value || '').split('/').pop(),
                        available: (node) => !node.disabled
                    }
                ];

                let fallbackId = null;
                for (const source of sources) {
                    for (const node of source.nodes) {
                        if (normalizeColor(source.color(node)) !== color) continue;
                        const id = (source.id(node) || '').trim();
                        if (!/^\d+$/.test(id)) continue;
                        if (source.available(node)) return id;
                        if (!fallbackId) fallbackId = id;
                    }
                }

                return fallbackId;
            }

            function currentVariantId(color) {
                const idForColor = variantIdForColor(color);
                if (idForColor) return idForColor;

                const resolved = window.__lvResolvedVariantId;
                if (resolved && /^\d+$/.test(String(resolved))) return String(resolved);

                const fromUrl = new URLSearchParams(window.location.search).get('variant');
                return fromUrl && /^\d+$/.test(fromUrl) ? fromUrl : null;
            }

            function retrySync() {
                if (retryCount >= MAX_RETRIES) return;
                retryCount++;
                clearTimeout(retryTimer);
                retryTimer = setTimeout(syncColor, RETRY_DELAY);
            }

            function render(color) {
                if (htmlByColor[color] !== undefined) {
                    renderedColor = color;
                    retryCount = 0;
                    content.innerHTML = htmlByColor[color];
                    return;
                }

                const variantId = currentVariantId(color);
                if (!variantId) {
                    retrySync();
                    return;
                }

                const token = ++requestToken;
                pendingColor = color;
                content.classList.add('complete-the-look__content--loading');

                fetch(`${productUrl}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`)
                    .then((response) => {
                        if (!response.ok) throw new Error(`Complete The Look section fetch failed: ${response.status}`);
                        return response.text();
                    })
                    .then((text) => {
                        if (token !== requestToken) return; // a newer color won
                        const holder = document.createElement('div');
                        holder.innerHTML = text;
                        const fresh = holder.querySelector('.complete-the-look__content');

                        if (!fresh) {
                            htmlByColor[color] = '';
                            renderedColor = color;
                            retryCount = 0;
                            content.innerHTML = '';
                            return;
                        }

                        const freshSection = holder.querySelector('section.complete-the-look');
                        const servedColor = freshSection
                            ? normalizeColor(freshSection.dataset.selectedColor)
                            : color;

                        htmlByColor[servedColor || color] = fresh.innerHTML;
                        renderedColor = servedColor || color;
                        content.innerHTML = fresh.innerHTML;

                        if (renderedColor === color) {
                            retryCount = 0;
                        } else {
                            retrySync();
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        if (token === requestToken) retrySync();
                    })
                    .finally(() => {
                        if (pendingColor === color) pendingColor = null;
                        if (token === requestToken) {
                            content.classList.remove('complete-the-look__content--loading');
                        }
                    });
            }

            function syncColor() {
                const color = getActiveColor();
                if (!color || color === renderedColor || color === pendingColor) return;

                if (color !== lastRequestedColor) {
                    lastRequestedColor = color;
                    retryCount = 0;
                }

                render(color);
            }

            function scheduleSync() {
                clearTimeout(debounceTimer);
                debounceTimer = setTimeout(syncColor, SYNC_DEBOUNCE);
            }

            const colorPicker = document.querySelector('#ProductDetails #color-picker');
            if (colorPicker) {
                if (window.__ctlColorObserver) window.__ctlColorObserver.disconnect();
                window.__ctlColorObserver = new MutationObserver(scheduleSync);
                window.__ctlColorObserver.observe(colorPicker, {
                    subtree: true,
                    childList: true,
                    attributes: true,
                    attributeFilter: ['class']
                });
            }

            teardown = function () {
                if (window.__ctlColorObserver) {
                    window.__ctlColorObserver.disconnect();
                    window.__ctlColorObserver = null;
                }
                clearTimeout(debounceTimer);
                clearTimeout(retryTimer);
                // bumping the token makes any in-flight fetch discard its response
                requestToken++;
            };
        }

        initCompleteTheLook();

        // theme editor only: an external asset does not re-run when a section re-renders
        document.addEventListener('shopify:section:load', function (event) {
            if (event.target && event.target.querySelector('section.complete-the-look')) {
                if (teardown) teardown();
                initCompleteTheLook();
            }
        });

        document.addEventListener('shopify:section:unload', function (event) {
            if (!event.target || !event.target.querySelector('section.complete-the-look')) return;
            if (teardown) {
                teardown();
                teardown = null;
            }
        });
        })();
